import React, { PureComponent } from 'react';
import ReactDOMServer from 'react-dom/server';
import PropTypes from 'prop-types';

import GeoJSONLayer from './geojson-layer';
import { CHOROPLETH_DEFAULTS } from 'constants/geospatial';
import { CustomPopupFields } from '../custom-popup';
import popupStyles from '../custom-popup/custom-popup.less';
import { ThemeContext } from 'constants/theme';

class GeochoroplethItem extends PureComponent {
  static propTypes = {
    geoJSON: PropTypes.object.isRequired,
    featureMap: PropTypes.object.isRequired,
    gradient: PropTypes.object,
    opacity: PropTypes.number,
  };

  static defaultProps = CHOROPLETH_DEFAULTS;

  onEachFeature = (feature, layer) => {
    const { id } = feature;
    const { fields } = this.props.featureMap[id] || {};

    if (!fields) {
      return;
    }

    const popup = ReactDOMServer.renderToString(
      <CustomPopupFields fields={fields || []} />
    );

    layer.bindPopup(popup, {
      closeButton: false,
      className: popupStyles.popup,
    });

    layer.on('mouseover', () => layer.openPopup());
    layer.on('mouseout', () => layer.closePopup());
  };

  render() {
    const { geoJSON, opacity, gradient, featureMap } = this.props;

    return (
      <ThemeContext.Consumer>
        {theme => (
          <GeoJSONLayer
            theme={theme}
            opacity={opacity}
            featureMap={featureMap}
            gradient={gradient}
            data={geoJSON}
            onEachFeature={this.onEachFeature}
          />
        )}
      </ThemeContext.Consumer>
    );
  }
}

export default GeochoroplethItem;
export { GeochoroplethItem };
